import { NotificationSeverity } from '../../interfaces/notification.interface';

export const SOURCE_LABELS: Record<string, string> = {
    SUPPLIER_BILL_DUE: 'Supplier bills due',
    SALES_INVOICE_OVERDUE: 'Sales invoices overdue',
    EXPORT_LC_EXPIRY: 'Export LC expiry',
    LC_LATEST_SHIPMENT: 'LC latest shipment date',
    UD_VALIDITY: 'UD validity',
    B2B_ACCEPTANCE_MATURITY: 'B2B acceptance maturity',
    VAT_RETURN_DUE: 'VAT return (Mushak 9.1) due',
    CUSTOMER_DUNNING_DUE: 'Customer dunning due',
    PROMISE_TO_PAY_DUE: 'Promise to pay due',
    BORROWING_EMI: 'Loan instalment / maturity due',
    CHEQUE_PDC: 'Post-dated cheques due',
    BANK_GUARANTEE_EXPIRY: 'Bank guarantee expiry',
    LC_MARGIN_EXPIRY: 'LC margin held, LC expiring',
    PAYMENT_RUN_APPROVAL_PENDING: 'Payment runs awaiting approval',
    FILING_CALENDAR: 'Filing calendar (statutory deadlines)',
    PF_CONTRIBUTION_RUN_DUE: 'Provident fund contribution run due',
    FDR_MATURITY: 'Fixed deposit (FDR) maturity',
    // ---- W3-W ----
    EXP_REPATRIATION_DUE: 'Export proceeds due for repatriation',
    // ---- end W3-W ----
    // ---- W3-M ----
    INTERCOMPANY_ACCEPT_PENDING: 'Inter-company transactions awaiting acceptance',
    // ---- end W3-M ----
};

export const sourceLabel = (key: string): string =>
    SOURCE_LABELS[key] ?? key.split('_').map(w => w.charAt(0) + w.slice(1).toLowerCase()).join(' ');

export const severityColor = (s: NotificationSeverity): 'default' | 'warning' | 'error' =>
    s === 'OVERDUE' ? 'error' : s === 'WARNING' ? 'warning' : 'default';

/** Offsets are days before the due date: 7 = a week ahead, 0 = on the day, -1 = a day after. */
export const parseOffsets = (text: string): number[] | null => {
    const parts = text.split(',').map(p => p.trim()).filter(p => p !== '');
    if (parts.length === 0 || parts.length > 12) return null;
    const nums = parts.map(p => (/^-?\d+$/.test(p) ? Number(p) : NaN));
    if (nums.some(n => Number.isNaN(n) || n < -365 || n > 365)) return null;
    return Array.from(new Set(nums)).sort((a, b) => b - a);
};

/** Only in-app paths may be navigated to: no external URLs and no protocol-relative links. */
export const isSafeDeepLink = (link?: string | null): link is string =>
    !!link && link.startsWith('/') && !link.startsWith('//');

/** Fired after the inbox changes (mark read / mark all) so the header bell re-fetches its count at once. */
export const NOTIFICATIONS_CHANGED_EVENT = 'oms:notifications-changed';
export const notifyNotificationsChanged = (): void => {
    window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED_EVENT));
};
